import {formatCurrency} from "~/utils";
import {Button, Icon} from "~/components";
import QuantitySuggestions from "./QuantitySuggestions";
import {useState, useEffect, useRef} from "react";
import '../style/CartItem.css';

const CartItem = ({item, onIncrease, onDecrease, onRemove, onQuantityChange}) => {
    // Calculate subtotal based on unit
    const subtotal = item.unit === 'kg'
        ? item.price * item.quantity * 10
        : item.price * item.quantity;

    const vatAmount = (subtotal * (item.vat || 0)) / 100;

    const total = subtotal + vatAmount;

    const [autoOpenPopover, setAutoOpenPopover] = useState(false);

    const isFirstRender = useRef(true);

    const inputRef = useRef(null);

    // Auto open popover when kg product is newly added with quantity = 0
    useEffect(() => {
        if (isFirstRender.current && item.unit === 'kg' && item.quantity === 0.1) {
            setAutoOpenPopover(true);
            isFirstRender.current = false;

            // Auto focus to input after popover opens
            setTimeout(() => {
                if (inputRef.current) {
                    inputRef.current.focus();
                    inputRef.current.select();
                }
            }, 100);
        }
    }, [item.unit, item.quantity]);

    const handleQuantityInputChange = (e) => {
        const value = parseFloat(e.target.value);

        // Validation based on unit
        if (item.unit === 'kg') {
            // Allow decimal values for kg
            if (value >= 0 || e.target.value === '') {
                onQuantityChange(item.id, value || 0);
            }
        } else {
            // Allow only integers for other units
            if (Number.isInteger(value) && value >= 0 || e.target.value === '') {
                onQuantityChange(item.id, value || 0);
            }
        }
    };

    return (
        <div className="pos-cart-item">
            <div className="pos-cart-item-header">
                <div className="pos-cart-item-info">
                    <h5 className="pos-cart-item-title">{item.title}</h5>
                    {item.attribute_label && (
                        <span className="pos-cart-item-attribute">{item.attribute_label}</span>
                    )}
                    <div className="pos-cart-item-price-line">
                        <span className="price-value">{formatCurrency(item.price)}</span>
                        {item.vat > 0 && (
                            <span className="vat-badge">VAT {item.vat}%</span>
                        )}
                    </div>
                </div>
                <Button
                    className="pos-cart-item-remove"
                    red
                    small
                    onClick={() => onRemove(item.id)}
                >
                    {Icon.delete}
                </Button>
            </div>

            <div className="pos-cart-item-footer">
                <div className="quantity-controls">
                    <Button
                        small
                        outline
                        onClick={() => onDecrease(item.id)}
                        disabled={item.quantity <= (item.unit === 'kg' ? 0.1 : 1)}
                    >
                        -
                    </Button>
                    <QuantitySuggestions
                        value={item.quantity}
                        unit={item.unit}
                        onChange={(value) => onQuantityChange(item.id, value)}
                        autoOpen={autoOpenPopover}
                    >
                        <input
                            ref={inputRef}
                            type="number"
                            className="quantity-input"
                            value={item.quantity}
                            onChange={handleQuantityInputChange}
                            min="0"
                            step={item.unit === 'kg' ? '0.1' : '1'}
                            placeholder={item.unit === 'kg' ? '0.0' : '0'}
                            title={item.unit === 'kg' ? 'Click để xem gợi ý (Kg)' : 'Click để xem gợi ý'}
                        />
                    </QuantitySuggestions>
                    <Button
                        small
                        outline
                        onClick={() => onIncrease(item.id)}
                    >
                        +
                    </Button>
                </div>

                <div className="pos-cart-item-total">
                    <span className="total-value">{formatCurrency(total)}</span>
                </div>
            </div>
        </div>
    );
};

export default CartItem;
